import { useChannelSettingsContext } from "@wearesweet/sendbird-uikit-react/ChannelSettings/context";
import Label, { LabelColors, LabelTypography } from "@wearesweet/sendbird-uikit-react/ui/Label";
import { Toggle } from "@wearesweet/sendbird-uikit-react/ui/Toggle";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { OFFICIAL } from "../../../utils/channelStatus";
import { OfficialIcon } from "./OfficialIcon";

export const ChannelOfficial = (props: any) => {
  const [official, setOfficial] = useState<boolean>(false);
  const { channel } = useChannelSettingsContext();

  useEffect(() => {
    setOfficial((channel && channel.customType.includes(OFFICIAL)) || false);
  }, [channel]);

  return (
    <div className="sendbird-channel-settings__freeze">
      <OfficialIcon className={"sendbird-channel-settings__accordion-icon"} />
      <Label type={LabelTypography.SUBTITLE_1} color={LabelColors.ONBACKGROUND_1}>
        {t("officialChannel")}
      </Label>
      <Toggle
        className="sendbird-channel-settings__frozen-icon"
        checked={official}
        onChange={() => {
          if (channel) {
            let newCustomType = channel.customType.replace("o", "");

            // they are toggling official on, so add p to the custom type
            if (!official) {
              newCustomType += "o";
            }

            channel
              .updateChannel({
                customType: newCustomType,
              })
              .then(() => {
                setOfficial(!official);
              });
          }
        }}
      />
    </div>
  );
};
